export default {
  path: ":alias/students",
  component: resolve => require(["@/views/students"], resolve),
  children: [
    {
      path: "list",
      component: resolve => require(["@/views/students/list"], resolve)
    },
    {
      path: ":studentId/courses/student-sign-ins",
      component: resolve =>
        require(["@/views/courses/student-sign-ins"], resolve)
    }
  ]
};
